import { Plugin } from "ckeditor5";
import ResponseTransformationUI from "./responseTransformationUI";
import ResponseTransformationEditing from "./responseTransformationEditing";

export default class ResponseTransformation extends Plugin {
  public static get requires() {
    return [ResponseTransformationEditing, ResponseTransformationUI];
  }

  public static get pluginName(): string {
    return "ResponseTransformation";
  }
}
